import { folderTabKey } from './folderTabEntry';
export var RequestListEntityType;
(function (RequestListEntityType) {
    RequestListEntityType["requestlist"] = "requestlist";
    RequestListEntityType["item"] = "requestlist_item";
})(RequestListEntityType || (RequestListEntityType = {}));
export var RequestListStatus;
(function (RequestListStatus) {
    RequestListStatus["NotSent"] = "NotStarted";
    RequestListStatus["InProgress"] = "InProgress";
    RequestListStatus["Completed"] = "Completed";
})(RequestListStatus || (RequestListStatus = {}));
export var LifeCycleStage;
(function (LifeCycleStage) {
    LifeCycleStage["Active"] = "Active";
    LifeCycleStage["Deleted"] = "Deleted";
    LifeCycleStage["Frozen"] = "Frozen";
})(LifeCycleStage || (LifeCycleStage = {}));
export var RequestListTaskStatus;
(function (RequestListTaskStatus) {
    RequestListTaskStatus["NotSent"] = "NotSent";
    RequestListTaskStatus["InProgress"] = "InProgress";
    RequestListTaskStatus["InReview"] = "InReview";
    RequestListTaskStatus["Completed"] = "Completed";
})(RequestListTaskStatus || (RequestListTaskStatus = {}));
export var PermissionPolicy;
(function (PermissionPolicy) {
    PermissionPolicy["CanCreateNewDocumentRequestInPlugin"] = "CanCreateNewDocumentRequestInPlugin";
    PermissionPolicy["CanAddItem"] = "CanAddItem";
    PermissionPolicy["CanCloseOrOpenDocumentRequest"] = "CanCloseOrOpenDocumentRequest";
    PermissionPolicy["CanStartDocumentRequest"] = "CanStartDocumentRequest";
    PermissionPolicy["CanDeleteDocumentRequest"] = "CanDeleteDocumentRequest";
    PermissionPolicy["CanModifyDocumentRequest"] = "CanModifyDocumentRequest";
    PermissionPolicy["CanRemoveItem"] = "CanRemoveItem";
    PermissionPolicy["CanModifyItem"] = "CanModifyItem";
    PermissionPolicy["CanReviewItem"] = "CanReviewItem";
    PermissionPolicy["CanShareItem"] = "CanShareItem";
    PermissionPolicy["CanAddActorToRequestListItem"] = "CanAddActorToRequestListItem";
    PermissionPolicy["CanRemoveActorFromRequestListItem"] = "CanRemoveActorFromRequestListItem";
    PermissionPolicy["CanSendItemForReview"] = "CanSendItemForReview";
    PermissionPolicy["CanRemoveAttachment"] = "CanRemoveAttachment";
    PermissionPolicy["CanAddAttachment"] = "CanAddAttachment";
    PermissionPolicy["CanDownloadAttachment"] = "CanDownloadAttachment";
    PermissionPolicy["CanDownloadAllItemAttachments"] = "CanDownloadAllItemAttachments";
    PermissionPolicy["CanShareDocumentRequest"] = "CanShareDocumentRequest";
    PermissionPolicy["CanRemoveActorFromRequestList"] = "CanRemoveActorFromRequestList";
    PermissionPolicy["CanRestoreDocumentRequests"] = "CanRestoreDocumentRequests";
    PermissionPolicy["CanViewDeletedItems"] = "CanViewDeletedItems";
})(PermissionPolicy || (PermissionPolicy = {}));
export var PermissionFailureReason;
(function (PermissionFailureReason) {
    PermissionFailureReason["RequiresItemInList"] = "RequiresItemInList";
    PermissionFailureReason["RequiresInProgressItem"] = "RequiresInProgressItem";
    PermissionFailureReason["RequiresSomeActors"] = "RequiresSomeActors";
    PermissionFailureReason["RequiresInProgressList"] = "RequiresInProgressList";
    PermissionFailureReason["RequiresNotCompletedList"] = "RequiresNotCompletedList";
    PermissionFailureReason["RequiresNotCompletedItem"] = "RequiresNotCompletedItem";
    PermissionFailureReason["RequiresStartedList"] = "RequiresStartedList";
    PermissionFailureReason["RequiresSentItem"] = "RequiresSentItem";
    PermissionFailureReason["RequiresNotSpecEditRenderMode"] = "RequiresNotSpecEditRenderMode";
})(PermissionFailureReason || (PermissionFailureReason = {}));
export var RequestListEvent;
(function (RequestListEvent) {
    RequestListEvent["RefreshDocumentRequestsChannel"] = "requestlists.requestlist.refresh";
    RequestListEvent["RefreshDocumentRequestTasksChannel"] = "requestlists.requestlist_item.refresh";
    RequestListEvent["OnAttachmentCountChanged"] = "urn:sfevent:request-list-pilet:attachment-count";
    RequestListEvent["OnResourceDeleted"] = "urn:event:resource:deleted";
    RequestListEvent["OnResourceUpdated"] = "urn:event:resource:updated";
    RequestListEvent["OnResourceCreated"] = "urn:event:resource:created";
})(RequestListEvent || (RequestListEvent = {}));
//# sourceMappingURL=types.js.map